import React from "react";
import _ from "lodash";
import Dialog from "@material-ui/core/Dialog";
import Button from "components/Button";
import Stepper from "pages/orders/CreateOrderStepper";
import CreateBasicOrder from "pages/orders/CreateBasicOrder";
import ShippingInformation from "pages/orders/ShippingInformation";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import COLORS from "shared/constants/colors";
import { ROUTES } from "shared/constants/routes";
import { useHistory } from "react-router-dom";

import {
  Heading,
  Container,
  BasicOrder,
  CreateOrderButton,
} from "styles/pages/orders/createOrder";

const CreateOrder = ({
  open,
  show,
  hide,
  handleNext,
  handleBack,
  activeStep,
  save,
}) => {
  const history = useHistory();
  return (
    <CreateOrderButton>
      <Button
        title="Create Order"
        onClick={() => _.isFunction(show) && show()}
        containerStyle={{
          background: COLORS.BLACK,
          boxShadow: "none",
          height: "34px",
          textTransform: "capitalize",
          color: COLORS.WHITE,
          marginRight: 10,
        }}
      />
      <Dialog
        maxWidth="md"
        open={open}
        onClose={() => _.isFunction(hide) && hide()}
      >
        <Container>
          {activeStep > 0 && (
            <Button
              containerStyle={{
                backgroundColor: "transparent",
                fontSize: "12px",
                borderRadius: "3px",
                padding: "3px 8px",
                lineHeight: "1.5",
                color: "#000",
                border: "1px solid #e7eaec",
                textTransform: "capitalize",
              }}
              startIcon={<ArrowBackIosIcon fontSize="small" />}
              variant="text"
              title="Go Back"
              onClick={() => _.isFunction(handleBack) && handleBack()}
            />
          )}
          <Stepper
            activeStep={activeStep}
            handleNext={handleNext}
            handleBack={handleBack}
          />

          {activeStep === 0 && (
            <React.Fragment>
              <Heading>
                Big Oven Tees takes 6-10 business days to fulfill your order(s).
              </Heading>
              <BasicOrder>
                <h3>Basic Order</h3>
                <p>
                  Bulk discounts for orders containing multiple items shipped to
                  the same address.
                </p>
                <CreateBasicOrder handleNext={handleNext} />
              </BasicOrder>
            </React.Fragment>
          )}

          {activeStep === 1 && (
            <ShippingInformation
              save={(payload) => _.isFunction(save) && save(payload)}
            />
          )}
        </Container>
      </Dialog>
    </CreateOrderButton>
  );
};

export default CreateOrder;
